import { useLogout } from 'hooks/useLogout';
import React from 'react';

const LogoutRoute: React.FunctionComponent = () => {
  const [doLogout] = useLogout();

  React.useEffect(() => {
    doLogout();
  }, [doLogout]);

  return null;
};

export default LogoutRoute;
